import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {ConfirmationService, SelectItem} from 'primeng/api';

import {Project, ProjectAccess} from '../../../../core/models/project';

import {ProjectService} from '../../../../core/services/project.service';
import {EventService, FileHelperService} from '../../../../core';
import {TokenService} from '../../../../core/auth';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ProjectSidebarService} from '../../../../projectsidebar.service';

@Component({
  selector: 'app-project-settings',
  templateUrl: './project-settings.page.html',
  styleUrls: ['./project-settings.page.scss']
})
export class ProjectSettingsPage implements OnInit {
  @Input() project: Project;
  saving = false;
  authUser = this.token.whoAmI();
  id: string;
  loading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private fileHelperService: FileHelperService,
    private token: TokenService,
    private eventService: EventService,
    private confirmationService: ConfirmationService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService,
  ) {

  }


  ngOnInit() {
    this.loadProject();
  }

  loadProject() {
    this.loading = true;
    this.route.parent.params.subscribe((params) => {
      this.id = params.id;
    });
    this.route.parent.data.subscribe((data) => {
      if (data.project) {
        this.project = Object.assign({}, data.project);
        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name},
          {label: 'settings'},
        ]);
        this.projectSidebarService.setProject(this.project);
      }
      this.loading = false;
    });

  }

  removeImage() {
    delete (this.project.image);
    delete (this.project.imageContents);
  }

  storeFile(event, element) {
    const file = event.files[0];
    if (!file.type.startsWith('image/')) {
      this.eventService.warn('invalid content, please upload an image');
      element.clear();
      return;
    }
    this.fileHelperService.fileToDataUrl(file, (data) => {
      this.project.imageContents = data;
    });
  }

  saveProject() {
    // const request = this.projectOrig;
    // request.name = this.project.name;
    // request.externalId = this.project.externalId;
    // request.image = this.project.imageContents;
    // request.status = this.project.status;
    this.saving = true;
    this.projectService.update(null/*request*/).subscribe(
      (data) => {
        delete (this.saving);
        this.project = data;
      }, (error) => {
        delete (this.saving);
      });
  }

}
